const reset = '\x1b[0m'

// @ts-ignore
const isBrowser = typeof window !== 'undefined'

const green = (str: string) => (isBrowser ? str : `\x1b[32m${str}${reset}`)
const cyan = (str: string) => (isBrowser ? str : `\x1b[36m${str}${reset}`)
const gray = (str: string) => (isBrowser ? str : `\x1b[90m${str}${reset}`)

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
function serializeValue(value: any): string {
  if (value == null) {
    return 'null'
  }

  if (value === undefined) {
    return 'undefined'
  }

  if (typeof value === 'string') {
    return green(`"${value.replace(/"/g, '\\"')}"`)
  }

  if (typeof value === 'number') {
    return cyan(`${value}`)
  }

  if (typeof value === 'boolean') {
    return `${value}`
  }

  if (typeof value === 'object' && Array.isArray(value)) {
    return `[${value.map((v) => serializeValue(v)).join(',')}]`
  }

  if (typeof value === 'object') {
    return `{${toLogFmt(value)}}`
  }

  return `${value}`
}

// Single function that works in both environments
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export function toLogFmt(obj: Record<string, any> | any[]): string {
  if (Array.isArray(obj)) {
    return serializeValue(obj)
  }

  return Object.entries(obj)
    .map(([key, value]) => {
      return `${gray(key)}=${serializeValue(value)}`
    })
    .join(' ')
}
